module.exports = __webpack_public_path__ + "static/media/hero_banner_767.23082743.jpg";